import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Career Routes and Pages
 */
const ListCareerPage = React.lazy(() => import("./ListCareerPage"));
const AddCareerPage = React.lazy(() => import("./AddCareerPage.js"));
const EditCareerPage = React.lazy(() => import("./EditCareerPage"));

const CareerRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListCareerPage />} />
      <Route exact path="/add" element={<AddCareerPage />} />
      <Route exact path="/edit/:id" element={<EditCareerPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default CareerRoutes;
